import React from "react";
import { hexToRgba } from "../../../utils/couleurs.js";
import { formatTypoloText } from "../../../utils/formatTypoloText.js";
//import "./ImageGrid.css";
import "./ImageCell.css";

const ImageCellOverlay = ({
  img,
  expanded,
  onClick,
}) => {
  return (
    <div
      className={`overlay ${expanded ? "expanded" : ""}`}
      style={{ backgroundColor: hexToRgba(img.typoloColor, 1) }}
      onClick={onClick}
    >
      <div className="overlay-inner">
        <div className="overlay-title">{img.nyme}</div>
        <div className="overlay-sub">{img.adress}</div>
      </div>
      {expanded && (
        <div className="overlay-extra">
          <div 
            className="overlay-typolo-a"
            style={{ backgroundColor: img.typoloColor }}
          >
            <span className="typolo-label">
              {/*img.typoloA.split("_").join(" ")*/}
              {formatTypoloText(img.typoloA)}
            </span>
            {img.date && img.date.trim() !== "" && (
              <span className="typolo-date">
                {img.date}
              </span>
            )}
          </div>
          {img.typoloB && img.typoloB.trim() !== "" && (
            <div 
              className="overlay-typolo-b"
              style={{ backgroundColor: img.typoloColorB }}
            >
              {/*img.typoloB.split("_").join(" ")*/}
              {formatTypoloText(img.typoloB)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageCellOverlay;